exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__news-header___abiam{position:absolute;bottom:0;flex-flow:row;color:#fafafa;width:100%;padding:1rem;box-sizing:border-box;z-index:2;text-decoration:none}.styles__news-header___abiam div{display:flex;flex-flow:row;align-items:center;border:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.styles__news-header___abiam .styles__title___3e5kg{padding-bottom:.75rem;display:block;justify-content:center;font-size:1.5rem}.styles__news-header___abiam .styles__bottom___IRozO{justify-content:space-between}.styles__news-header___abiam .styles__tags___2My3I{display:flex;justify-content:flex-end;width:100%;margin-top:.25rem}.styles__news-header___abiam .styles__tags___2My3I .styles__tag___3H1uf{margin:0 .5rem;padding:.25rem .75rem;background-color:hsla(0,0%,100%,.35);border-radius:2rem}", ""]);

// exports
exports.locals = {
	"news-header": "styles__news-header___abiam",
	"title": "styles__title___3e5kg",
	"bottom": "styles__bottom___IRozO",
	"tags": "styles__tags___2My3I",
	"tag": "styles__tag___3H1uf"
};